/**
 * Page context sent with each assistant message.
 * The panel does not decide this. The host reads the current route.
 */

/**
 * @param {string} pathname
 * @returns {{ view: string, jobId?: string, legId?: string }}
 */
export function pageContextFromPath(pathname) {
  const path = String(pathname || "");
  const jobMatch = path.match(/\/jobs\/([^/]+)/);
  const legMatch = path.match(/\/legs\/([^/]+)/);
  if (jobMatch) {
    return {
      view: "load",
      jobId: jobMatch[1],
      ...(legMatch ? { legId: legMatch[1] } : {}),
    };
  }
  if (path.includes("/dispatch")) return { view: "dispatch" };
  if (path.includes("/reports")) return { view: "reports" };
  return { view: "dashboard" };
}
